// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ServicesCard_cardWrapper__NkNOb {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 16px;
  width: 229px;
  height: 212px;
  border: 1px solid #e6eaed;
  padding: 20px;
  border-radius: 16px;
  background-color: white;
  position: relative;
  box-sizing: border-box;
}

.ServicesCard_cardWrapper__NkNOb:hover {
  border: 2px solid #47a9f4;
  cursor: pointer;
}

.ServicesCard_cardWrapper__NkNOb:hover > .ServicesCard_title__YQNJY,
.ServicesCard_divider__HkwwH {
  color: #47a9f4;
}

.ServicesCard_cardWrapper__NkNOb:hover > .ServicesCard_divider__HkwwH path {
  stroke: #47a9f4;
}

.ServicesCard_labelWrapper__jewp3 {
  position: absolute;
  bottom: 176px;
  right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  background-color: #47a9f4;
  width: 82px;
  height: 34px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  z-index: 1;
}
.ServicesCard_title__YQNJY,
.ServicesCard_label__oqPL\\+ {
  font-family: "Open Sans";
  font-weight: 700;
  letter-spacing: 0px;
  text-align: left;
}
.ServicesCard_title__YQNJY {
  max-width: 16ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  overflow-wrap: break-word;
  margin-block-end: -5px;
}
.ServicesCard_divider__HkwwH {
  width: 70px;
  height: 4px;
}
.ServicesCard_label__oqPL\\+ {
  font-size: 14px;
  line-height: 19px;
  color: #ffffff;
}

@media screen and (max-width: 680px) {
  .ServicesCard_cardWrapper__NkNOb {
    width: 150px;
    height: 140px;
    box-sizing: content-box;
  }
  .ServicesCard_labelWrapper__jewp3 {
    bottom: 146px;
  }
}
@media screen and (max-width: 480px) {
  .ServicesCard_cardWrapper__NkNOb {
    width: 130px;
    height: 120px;
  }
  .ServicesCard_title__YQNJY {
    font-size: 14px;
  }
  .ServicesCard_labelWrapper__jewp3 {
    bottom: 126px;
  }
}

@media screen and (max-width: 410px) {
  .ServicesCard_cardWrapper__NkNOb {
    width: 120px;
    height: 112px;
  }
  .ServicesCard_title__YQNJY {
    font-size: 13px;
  }
  .ServicesCard_labelWrapper__jewp3 {
    bottom: 124px;
    height: 28px;
  }
}

@media screen and (max-width: 360px) {
  .ServicesCard_cardWrapper__NkNOb {
    width: 88px;
    height: 85px;
  }
  .ServicesCard_title__YQNJY {
    font-size: 12px;
  }
  .ServicesCard_labelWrapper__jewp3 {
    bottom: 100px;
  }
}

@media screen and (max-width: 335px) {
  .ServicesCard_cardWrapper__NkNOb {
    width: 85px;
    height: 80px;
  }
  .ServicesCard_title__YQNJY {
    font-size: 11px;
  }
  .ServicesCard_labelWrapper__jewp3 {
    bottom: 95px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/ServicesCard/ServicesCard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,UAAU;AACZ;AACA;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".cardWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-end;\n  gap: 16px;\n  width: 229px;\n  height: 212px;\n  border: 1px solid #e6eaed;\n  padding: 20px;\n  border-radius: 16px;\n  background-color: white;\n  position: relative;\n  box-sizing: border-box;\n}\n\n.cardWrapper:hover {\n  border: 2px solid #47a9f4;\n  cursor: pointer;\n}\n\n.cardWrapper:hover > .title,\n.divider {\n  color: #47a9f4;\n}\n\n.cardWrapper:hover > .divider path {\n  stroke: #47a9f4;\n}\n\n.labelWrapper {\n  position: absolute;\n  bottom: 176px;\n  right: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  background-color: #47a9f4;\n  width: 82px;\n  height: 34px;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  z-index: 1;\n}\n.title,\n.label {\n  font-family: \"Open Sans\";\n  font-weight: 700;\n  letter-spacing: 0px;\n  text-align: left;\n}\n.title {\n  max-width: 16ch;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n  overflow-wrap: break-word;\n  margin-block-end: -5px;\n}\n.divider {\n  width: 70px;\n  height: 4px;\n}\n.label {\n  font-size: 14px;\n  line-height: 19px;\n  color: #ffffff;\n}\n\n@media screen and (max-width: 680px) {\n  .cardWrapper {\n    width: 150px;\n    height: 140px;\n    box-sizing: content-box;\n  }\n  .labelWrapper {\n    bottom: 146px;\n  }\n}\n@media screen and (max-width: 480px) {\n  .cardWrapper {\n    width: 130px;\n    height: 120px;\n  }\n  .title {\n    font-size: 14px;\n  }\n  .labelWrapper {\n    bottom: 126px;\n  }\n}\n\n@media screen and (max-width: 410px) {\n  .cardWrapper {\n    width: 120px;\n    height: 112px;\n  }\n  .title {\n    font-size: 13px;\n  }\n  .labelWrapper {\n    bottom: 124px;\n    height: 28px;\n  }\n}\n\n@media screen and (max-width: 360px) {\n  .cardWrapper {\n    width: 88px;\n    height: 85px;\n  }\n  .title {\n    font-size: 12px;\n  }\n  .labelWrapper {\n    bottom: 100px;\n  }\n}\n\n@media screen and (max-width: 335px) {\n  .cardWrapper {\n    width: 85px;\n    height: 80px;\n  }\n  .title {\n    font-size: 11px;\n  }\n  .labelWrapper {\n    bottom: 95px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardWrapper": `ServicesCard_cardWrapper__NkNOb`,
	"title": `ServicesCard_title__YQNJY`,
	"divider": `ServicesCard_divider__HkwwH`,
	"labelWrapper": `ServicesCard_labelWrapper__jewp3`,
	"label": `ServicesCard_label__oqPL+`
};
export default ___CSS_LOADER_EXPORT___;
